import { timestamp, isURL } from '../utils';
import { ResourceTiming, SetNodeURLBasedAttribute } from '../messages';
export default function (app) {
    const sendImgSrc = app.safe(function () {
        const id = app.nodes.getID(this);
        if (id === undefined) {
            return;
        }
        const { src, complete, naturalWidth, naturalHeight } = this;
        if (!complete) {
            return;
        }
        if (naturalWidth === 0 && naturalHeight === 0) {
            if (isURL(src)) {
                app.send(ResourceTiming(timestamp(), 0, 0, 0, 0, 0, src, 'img'));
            }
        }
        else if (src.length < 1e5) {
            const baseURL = location.origin + location.pathname;
            app.send(SetNodeURLBasedAttribute(id, 'src', src, baseURL));
        }
    });
    app.nodes.attachNodeCallback((node) => {
        if (!(node instanceof HTMLImageElement)) {
            return;
        }
        app.nodes.attachElementListener('error', node, sendImgSrc);
        app.nodes.attachElementListener('load', node, sendImgSrc);
        sendImgSrc.call(node);
    });
}
